module.exports = __webpack_public_path__ + "resources/img/big-banner-v5.0c759589.jpg";